import { Navigate, useLocation } from 'react-router-dom';
import { useApp } from '../contexts/AppContext';
import '../views/Login.css';

export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { token, loading } = useApp();
  const location = useLocation();

  if (loading) {
    return (
      <div className="auth-loading">
        <div className="auth-loading-spinner" />
        <span>Loading...</span>
      </div>
    );
  }

  if (!token) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return <>{children}</>;
}
